import {playablePool} from "./PlayablePool";
import {AbstractPlayableContent, TemporalIndicators} from "../models/AbstractPlayableContent";
import {Part} from "../models/Part";
import {Section} from "../models/Section";
import {PlayableType} from "../../global/types/GlobalTypes";

export function createPartsFromVersionJson(versionJson: any) {
  versionJson.parts.forEach((part: any) => {
    if (!playablePool.exists('part', part.id)) {
      for (const partIndex in part.indexed_occurrences) {
        const temporalIndicator = new TemporalIndicators(
          part.indexed_occurrences[partIndex], part.division_qty,
          versionJson.division_per_beat, versionJson.beat_per_measure, versionJson.sections[0].tempo, parseInt(partIndex)
        )
        playablePool.add(new Part(part.id, temporalIndicator, part));
      }
    }
  })
}

export function createSectionsFromMainPlayableJson(versionJson: any) {
  versionJson.sections.forEach((sectionJson: any) => {
    // Update these value because old system didn't allow section to carry following information; there is a risk that by
    // using section actual information might lead to issues in player and midi timeline. Need to test it in depth before implementation.
    sectionJson.division_per_beat = versionJson.division_per_beat;
    sectionJson.beat_per_measure = versionJson.beat_per_measure;
    sectionJson.tempo = versionJson.sections[0].tempo;

    createSectionFromJson(sectionJson);
  })
}
export function createSectionFromJson(sectionJson: any) {
  if (!playablePool.exists('section', sectionJson.id)) {
    const temporalIndicator = new TemporalIndicators(
      sectionJson.in_sheet_first_occurrence_start_div ?? 0, sectionJson.division_qty,
      sectionJson.division_per_beat, sectionJson.beat_per_measure, sectionJson.tempo, -1
    )

    playablePool.add(new Section(sectionJson.id, temporalIndicator, sectionJson));
    // TODO: determine difference between use of part as a model or as a playable content
  }
}

// TODO Could add to playable pool with index identifier.
export function computePlayableTimeline(timeline: any[], playableType: PlayableType, offset: number = 0): AbstractPlayableContent[] {
  const playableTimeline = [] as AbstractPlayableContent[];

  let startTime = offset;
  timeline.forEach((id: number, index: number) => {
    const playableContent = playablePool.get(playableType, id)!;

    const temporalIndicator = TemporalIndicators.fromBaseTemporalIndicators(playableContent.temporalIndicators, startTime, index);
    startTime += playableContent.temporalIndicators.duration;

    switch (playableType) {
      case "part":
        playableTimeline.push(new Part(id, temporalIndicator, playableContent.baseModel));
        break;
      case "section":
        playableTimeline.push(new Section(id, temporalIndicator, playableContent.baseModel));
        break;
    }
  });

  return playableTimeline;
}
